import { useState } from "react";
import { toast } from "sonner";
import { Ban } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const BLOCK_DESCRIPTION = "Nenhum dos dois verá as publicações, comentários ou perfil do outro, e não será possível trocar mensagens, reações ou pedidos. Podes desbloquear a qualquer momento em Perfil › Utilizadores bloqueados.";

export async function blockUser(userId) {
  await api.post(`/users/${userId}/block`);
  window.dispatchEvent(new CustomEvent("auk:user-blocked", { detail: { userId } }));
}
export async function unblockUser(userId) {
  await api.delete(`/users/${userId}/block`);
}

/** Diálogo de confirmação de bloqueio controlado pelo pai (open/onOpenChange). */
export function BlockConfirmDialog({ open, onOpenChange, userId, userName, onBlocked }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await blockUser(userId); toast.success(`${userName || "Utilizador"} bloqueado`); onOpenChange(false); onBlocked?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Não foi possível bloquear"); }
    finally { setBusy(false); }
  };
  return (
    <AlertDialog open={open} onOpenChange={(o) => !busy && onOpenChange(o)}>
      <AlertDialogContent className="rounded-2xl max-w-sm" data-testid={`block-confirm-${userId}`}>
        <AlertDialogHeader>
          <AlertDialogTitle>Bloquear {userName || "este utilizador"}?</AlertDialogTitle>
          <AlertDialogDescription>{BLOCK_DESCRIPTION}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid={`block-confirm-cancel-${userId}`} className="rounded-xl">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); run(); }} disabled={busy} data-testid={`block-confirm-yes-${userId}`} className="rounded-xl bg-[#c8102e] hover:bg-[#a50c24]">
            {busy ? "A bloquear…" : "Bloquear"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

/** Botão «Desbloquear» simples (perfil bloqueado / lista de bloqueados). */
export function UnblockButton({ userId, onDone, className = "" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await unblockUser(userId); toast.success("Utilizador desbloqueado"); onDone?.(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Erro"); }
    finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={run} disabled={busy} data-testid={`unblock-btn-${userId}`}
            className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-lg border border-zinc-300 text-xs font-semibold hover:bg-zinc-50 disabled:opacity-50 ${className}`}>
      <Ban size={12} /> {busy ? "…" : "Desbloquear"}
    </button>
  );
}
